import { push } from "react-router-redux";
import { store } from "../Store/store";


export default {
  gotoPage: (url) => store.dispatch(push(url))
}


// WEBPACK FOOTER //
// ./src/services/AppService.js